import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  ledgerChartCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";

/**
 * Désactive un compte comptable (`DELETE /ChartOfAccounts/{id}`) — réservé
 * à flashpay-superadmin. Aucune suppression physique : l'historique
 * comptable reste intact ; seul le code HTTP fait foi (pas de corps typé).
 */
export const useDeleteChartOfAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["ledger", "chart-of-accounts", "delete"],
    mutationFn: (chartOfAccountId: string) =>
      mutateData({
        url: ledgerEndpoints.chartOfAccounts.delete(chartOfAccountId),
        method: "DELETE",
      }),
    onSuccess: (_data, chartOfAccountId) => {
      return invalidateAfterMutation(
        queryClient,
        ledgerChartCacheKeys(chartOfAccountId)
      );
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDeleteChartOfAccount failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "ledger" }
      );
    },
  });
};
